import script from "./CpfModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CpfModal.vue?vue&type=script&setup=true&lang=js"

import "./CpfModal.vue?vue&type=style&index=0&id=4b9c434c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b9c434c"]])

export default __exports__